import { useSyncExternalStore } from 'react';

const subscribeTheme = (onChange: () => void) => {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  return () => observer.disconnect();
};

const getDarkSnapshot = () => document.documentElement.classList.contains('dark');

export const useReportChartThemeKey = (): string =>
  useSyncExternalStore(subscribeTheme, getDarkSnapshot, () => false) ? 'dark' : 'light';
